import CloseButton from '../../../../shared/CloseButton';

export function CrewPickerHeader({ noun, onClose }: { noun: string; onClose: () => void }) {
  return (
    <div
      className="nb-card-hd"
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: 10,
      }}
    >
      <h3>Add {noun}</h3>
      <CloseButton onClick={onClose} />
    </div>
  );
}
